"use client";
import React from "react";
import Image from "next/image";

const HeroSection: React.FC = () => {
  return (
    <header className="relative w-full h-[300px] sm:h-[400px] 2xl:h-[600px] items-center">
      {/* Imagen optimizada */}
      <Image
        src="/assets/images/frontpage.png"
        alt="Atua Logo"
        blurDataURL="/assets/images/frontpage.png"
        placeholder="blur"
        fill={true}
        priority={true}
        className="object-cover w-full h-full"
      />
    </header>
  );
};

export default HeroSection;
